export default "__VITE_ASSET__DALr_gQ8__"